import { logos } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/gameplay.css */
  .bottom_yb_graph_buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15px;
    /* margin: 15px 0 0 0; */
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  .bottom_yb_graph_buttons button {
    padding: 11px 28px 10px 45px;
    background: linear-gradient(
      rgba(255, 255, 255, 0.1),
      rgba(245, 245, 245, 0.1),
      rgba(232, 232, 232, 0.1),
      rgba(222, 222, 222, 0.1),
      rgba(212, 212, 212, 0.1),
      rgba(201, 201, 201, 0.1),
      rgba(191, 191, 191, 0.1),
      rgba(181, 181, 181, 0.1)
    );
    font-size: 0.9rem;
    position: relative;
    font-weight: 600;
  }
  .bottom_yb_graph_buttons button:hover {
    background: linear-gradient(
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15)
    );
  }
  .bottom_yb_graph_buttons a {
    border-radius: 10px;
    padding: 11px 28px 10px 45px;
    background: linear-gradient(
      rgba(255, 255, 255, 0.1),
      rgba(245, 245, 245, 0.1),
      rgba(232, 232, 232, 0.1),
      rgba(222, 222, 222, 0.1),
      rgba(212, 212, 212, 0.1),
      rgba(201, 201, 201, 0.1),
      rgba(191, 191, 191, 0.1),
      rgba(181, 181, 181, 0.1)
    );
    font-size: 0.9rem;
    position: relative;
    font-weight: 600;
    text-decoration: none;
  }
  .bottom_yb_graph_buttons a:hover {
    background: linear-gradient(
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.15)
    );
    color: #fff;
  }
  .bottom_yb_graph_buttons button.view_on_yolorekt {
    display: flex;
    margin: 0 0 0 5px;
  }
  .bottom_yb_graph_buttons button.bid_on_yolobot {
    margin: 0 5px 0 0;
  }
  .bottom_yb_graph_buttons button.bid_on_yolobot:before {
    background: url(${logos.yolobot_icon}) left center / 15px auto no-repeat;
    width: 15px;
    height: 15px;
    position: absolute;
    top: 50%;
    left: 22px;
    transform: translateY(-50%);
    content: '';
  }
  .bottom_yb_graph_buttons button.view_on_yolorekt:before {
    background: url(${logos.yolorekt_moon_white}) left center / 15px auto no-repeat;
    width: 15px;
    height: 15px;
    position: absolute;
    top: 50%;
    left: 22px;
    transform: translateY(-50%);
    content: '';
  }
  @media (max-width: 600px) {
    .bottom_yb_graph_buttons button.view_on_yolorekt {
      display: none;
    }
  }
`

const developerCSS = css``

export const YoloBotGraphCSS = styled.div`
  display: grid;
  grid-template: auto 1fr auto / 1fr;
  gap: 15px;
  ${designerCSS}
  ${developerCSS}
`
